var map = {
	"./background-magazine.jpg": 36,
	"./background-wine.png": 37,
	"./bg-papier.jpg": 38,
	"./flags/be.svg": 39,
	"./flags/cn.svg": 40,
	"./flags/de.svg": 41,
	"./flags/es.svg": 42,
	"./flags/fr.svg": 43,
	"./flags/gb.svg": 44,
	"./flags/it.svg": 45,
	"./flags/jp.svg": 46,
	"./flags/us.svg": 47,
	"./icons/arrow-article.svg": 48,
	"./icons/back.svg": 49,
	"./icons/close.svg": 50,
	"./icons/error.svg": 51,
	"./icons/facebook.svg": 52,
	"./icons/info.svg": 53,
	"./icons/instagram.svg": 54,
	"./icons/linkedin.svg": 55,
	"./icons/marker.svg": 56,
	"./icons/pinterest.svg": 57,
	"./icons/slider-arrow.svg": 58,
	"./icons/success.svg": 59,
	"./icons/twitter.svg": 60,
	"./icons/weibo.svg": 61,
	"./icons/youtube.svg": 62,
	"./logo.png": 63,
	"./logo.svg": 64,
	"./marker.svg": 65,
	"./menu-bg.png": 66,
	"./pattern.png": 67,
	"./wine-shadow.png": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;